import { atom } from 'jotai';

import type { DownloadResponse } from '../types';

/**
 * Configuration for polling a specific download
 * Stored separately from main state because functions can't be serialized
 */
export type PollingConfig = {
  pollFn: () => Promise<unknown>;
  getStatusFromPoll: (response: unknown) => DownloadResponse;
  getDownloadUrl: (response: unknown) => string | undefined;
  getDownloadUrlFromPoll?: (response: unknown) => string | undefined;
  pollInterval: number;
  maxPollAttempts: number;
};

/**
 * Registry of poll functions indexed by download ID
 * In-memory only, cleared on page refresh
 */
export const pollingRegistryAtom = atom<Record<string, PollingConfig>>({});
